<!-- Page Article -->
<template>
  <div>
    <button
      v-if="canGoBack"
      @click="goBack"
      class="btn btn-outline-secondary mt-3 mb-3"
    >
      <i class="bi bi-arrow-left"></i> Назад
    </button>

    <h1>{{ articleName(recipe.articletype) }}</h1>
    <div class="description text-secondary mb-3">{{ recipe.name }}</div>

    <!-- Article of the Day -->
    <ArticleOfTheDay :id="currentArticleId" @recipe="recipe = $event" />
  </div>
</template>

<script>
import ArticleOfTheDay from "../ArticleOfTheDay.vue";

export default {
  name: "PageArticle",
  components: {
    ArticleOfTheDay,
  },

  data() {
    return {
      currentArticleId: 0,
      canGoBack: false,
      recipe: {},
    };
  },

  created() {
    this.handleRouteChange();
  },

  mounted() {
    this.canGoBack = window.history.length > 1;
    window.addEventListener("hashchange", this.handleRouteChange);
  },

  unmounted() {
    window.removeEventListener("hashchange", this.handleRouteChange);
  },

  methods: {
    goBack() {
      window.history.back();
    },

    handleRouteChange() {
      if (!window.location.hash.startsWith("#/article/")) {
        return;
      }
      const parts = window.location.hash.split("/");
      const articleId = parts[parts.length - 1];

      if (articleId && articleId !== this.currentArticleId) {
        this.currentArticleId = parseInt(articleId, 10);
      }
    },

    articleName(articletype) {
      switch (articletype) {
        case "article":
          return "История";
        case "recipe_of_the_day":
          return "Рецепт дня";
        default:
          return "Статья";
      }
    },
  },
};
</script>
